import styles from './index.module.scss';
import SubmitCta from './Buttons/SubmitCta';
import { useCallback, useState } from 'react';
import TriggerMockModal from '../Modals/TriggerMockModal/TriggerApproveMockModals';
import { ModalStep } from '../../types';
import MockDetailsTimeline from './States/MockDetailsTimeline';

const FieldAllocationsRightPanel = () => {
  const [modalState, setModalState] = useState({
    isVisible: false,
    currentStep: ModalStep.VALIDATE
  });

  const handleOpenModal = useCallback(() => {
    setModalState(prev => ({
      ...prev,
      currentStep: ModalStep.VALIDATE,
      isVisible: true
    }));
  }, []);

  return (
    <div className="flex w-full h-full flex-col justify-between">
      <div className={styles.rightPanel}>
        <MockDetailsTimeline />
      </div>
      <SubmitCta onSubmit={handleOpenModal} />
      <TriggerMockModal modalState={modalState} setModalState={setModalState} />
    </div>
  );
};

export default FieldAllocationsRightPanel;
